import FormElementMixin from '../mixins/FormElementMixin.js';
import FormElementWithPlaceholdersMixin from "../mixins/FormElementWithPlaceholdersMixin";

Vue.asyncComponent('ak-input-text-with-placeholders', {
    mixins: [FormElementMixin, FormElementWithPlaceholdersMixin],
    props: {
        type: {
            type: String,
            default: 'text'
        },
        icon: {
            type: String,
        },
        showClear: {
            type: Boolean,
        }
    },
    methods: {
        triggerClear() {
            this.currentValue = "";
            this.$emit('clear', "");
        }
    }
}, 'form/controls/ak-input-text-with-placeholders.html');